import * as types from '../../action-types';

export function setKlarnaStatus(status) {
  return {type: types.SET_KLARNA_STATUS, status};
}

export function setKlarnaError(error) {
  return {type: types.SET_KLARNA_ERROR, error};
}

export function setKlarnaSession(session) {
  return {type: types.SET_KLARNA_SESSION, session};
}

export function setLoadKlarnaCategoryResponse(categoryID, response) {
  return {type: types.SET_LOAD_KLARNA_CATEGORY_RESPONSE, categoryID, response};
}

export function setAuthKlarnaCategoryResponse(categoryID, response) {
  return {type: types.SET_AUTH_KLARNA_CATEGORY_RESPONSE, categoryID, response};
}

export function setKlarnaCustomerDetails(fieldName, fieldValue) {
  return {type: types.SET_KLARNA_CUSTOMER_DETAILS, fieldName, fieldValue};
}
